// Youtube
function Loadyoutube_Api() {
    var FireEvent = function(){
        var event = new CustomEvent('de_youtube_ready');
        document.dispatchEvent(event);
    }

    window.onYouTubeIframeAPIReady = function (){
        FireEvent();
    }

    if(typeof YT !== 'undefined' && typeof YT.ready === 'function'){
        window.console && console.log('YT Already loaded');
        FireEvent();
    } else {
        window.console && console.log('YT Loading Api script');
        var tag = document.createElement('script');

        tag.src = "https://www.youtube.com/iframe_api";
        var firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
    }

}

if (typeof sofitel_video_id !== 'undefined') {
    var player = null;

    $('#play_video_ss').on('click', function () {
        Loadyoutube_Api();
        document.addEventListener('de_youtube_ready', function(){
            $('#play_video_ss').addClass('loaded');
            if(player === null){
                player = new YT.Player('player', {
                    height: '360',
                    width: '640',
                    videoId: sofitel_video_id,
                    playerVars: {
                        autoplay: 0,
                        controls: 0,
                        disablekb: 1,
                        playlist: sofitel_video_id,
                        loop: 0,
                        modestbranding: 0,
                        showinfo: 0,
                        rel: 0,
                    },
                    events: {
                        'onReady': onPlayerReady,
                        'onStateChange': onPlayerStateChange
                    }
                });
            } else {
                window.console && console.log('Player already exist!!!!');
                onPlayerReady();
            }

        });
    });

    function onPlayerReady(event) {
        if ($('#play_video_ss.loaded').length > 0) {
            player.setVolume(30);
            $('html').addClass('playing-video');
            player.playVideo();
            $('.player_wrapper').fadeIn('fast');
            $('#slideshow_wrapper #play_video_ss, #slideshow_wrapper .arrows').fadeOut('fast');
        }
    }

    function onPlayerStateChange(event) {
        if (event.data === YT.PlayerState.ENDED) {
            $('html').removeClass('playing-video');
            $('.player_wrapper').fadeOut('fast');
            $('#slideshow').css('visibility', 'visible');
            $('#slideshow_wrapper #play_video_ss, #slideshow_wrapper .arrows').fadeIn('fast');
            $('#play_video_ss').removeClass('loaded');
            stopVideo();
        }

        $('.player_wrapper .stop').on('click', function () {
            $('html').removeClass('playing-video');
            $('.player_wrapper').fadeOut('fast');
            $('#slideshow').css('visibility', 'visible');
            $('#slideshow_wrapper #play_video_ss, #slideshow_wrapper .arrows').fadeIn('fast');
            $('#play_video_ss').removeClass('loaded');
            stopVideo();
        });

        $('.controls .player').on('click', function () {
            var state = player.getPlayerState();
            if (state === 1) {
                $(this).find('i').removeClass('fa-pause-circle');
                $(this).find('i').addClass('fa-play-circle');
                event.target.pauseVideo();
            } else {
                $(this).find('i').removeClass('fa-play-circle');
                $(this).find('i').addClass('fa-pause-circle');
                event.target.playVideo();
            }
        });

        $('.volume').on('click', function () {
            var icon = $('.volume i');
            var up = 'fa-volume-up';
            var down = 'fa-volume-down';
            var mute = 'fa-volume-mute';

            if (icon.hasClass(down)) {
                player.setVolume(100);
                setTimeout(function () {
                    icon.removeClass(down);
                    icon.addClass(up);
                }, 100);
            } else if (icon.hasClass(up)) {
                player.setVolume(0);
                setTimeout(function () {
                    icon.removeClass(up);
                    icon.addClass(mute);
                }, 100);
            } else if (icon.hasClass(mute)) {
                player.setVolume(30);
                setTimeout(function () {
                    icon.removeClass(mute);
                    icon.addClass(down);
                }, 100);
            }
        });
    }

    function stopVideo() {
        player.stopVideo();
    }
}